import style from './jumbotron2CompoStyle.module.css';
import playstore from '../../assets/images/Section-Footer-Button-Download-Playstore-Large.svg';
import Aos from 'aos';
import 'aos/dist/aos.css';
import { useEffect } from 'react';
const JumboTron2 = () => {
  useEffect(() => {
    Aos.init({
      duration: 300,
      easing: 'ease-in-sine',
      offset: 200,
      delay: 100,
    });
  }, []);
  return (
    <div className={`${style['jumbotron-2']} jumbotron-fluid mb-0`}>
      <div className={`${style['container-fluid']} mb-0`}>
        <div className="row">
          <div className={`${style.kolom1} col-lg-12`}>
            <div className="row">
              <div className={`${style.heading} col-lg-6 `}>
                <h1>
                  Download Aplikasi <br />
                  Sepakat
                </h1>
                <p className="lead-1">#MudahCariProperti</p>
                <a
                  href="https://play.google.com/store/apps/details?id=id.asc.sepakat"
                  target="_blank"
                  rel="noreferrer"
                >
                  <img
                    src={playstore}
                    alt=""
                    width="35%"
                    className={style.playstore}
                  />
                </a>
              </div>
              <div className={`${style.logoHp} col-lg kolom2 d-flex flex-row`}>
                <span className={style.hp1}>
                  <img
                    src={require('../../assets/images/Section-Footer-Vectary texture.png')}
                    alt=""
                  />
                </span>
                <span className={style.hp2}>
                  <img
                    src={require('../../assets/images/Section-Footer-Vectary texture-1.png')}
                    alt=""
                  />
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default JumboTron2;
